import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { mobile, mobileM, tablet } from "../responsive";
import Product from "../components/Product";
import products from "../products";

/*


This are the products on the Front page
Here you map the products to be used in the pages

*/

const HomeWrapper = styled.div`
  padding: 70px 0 100px 0;
  width: 100vw;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .link-All-products {
    background-color: transparent;
    padding: 10px 20px;
    border: 0;
  }
`;

const GalleryWrapper = styled.div`
  width: 100%;
  padding: 0px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //
  ${mobile({ width: "100%", padding: "100px 0 50px 0" })}
  ${mobileM({ width: "100%" })}
  ${tablet({ width: "100%" })};
`;

const H1 = styled.h1`
  padding: 70px 0 0 0;
  font-weight: 600;
  font-size: 1.6em;
  font-family: "Poppins-Light";
  text-transform: Capitalize;
  letter-spacing: 3px;
  text-align: center;
  color: #272727f8;
`;
const H2 = styled.h1`
  padding: 0 0 40px 0;
  line-height: 20px;
  font-weight: 600;
  font-size: 0.9em;
  font-family: "Poppins-Light";
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;

  color: #272727e6;
  ${mobile({
    lineHeight: "calc(11px + 1.4vmin)",
    fontSize: "calc(11px + 1.4vmin)",
  })}
`;

//
const H3 = styled.h3`
  .navLinks {
    margin: 0 5px 0 5px;
    //
    padding: 0 0 40px 0;
    line-height: 20px;
    font-weight: 600;
    font-size: 0.9em;
    font-family: "Poppins-Light";
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;

    color: #272727e6;

    //
    text-decoration: none;
    transition: 0.2s ease;
    cursor: pointer;
    //
    //related to underline animation -----------

    position: relative;
    /* z-index: 4; */
    padding-bottom: 2px;
    //  underline animation

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      transform: scaleX(0);
      height: 2.2px;

      bottom: 0;
      left: 0;
      background-color: #272727e6;
      transform-origin: bottom right;
      transition: transform 0.35s ease-out;
    }

    &:hover {
      &::after {
        transform: scaleX(1);
        transform-origin: bottom left;
      }
    }
  }
  //

  ${mobile({ fontSize: "1.2em", color: "#87411249", fontWeight: "500" })}
`;

//
//
//
const GalleryProductContainer = styled.div`
  width: 100%;

  padding: 30px 5px;
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  grid-gap: 0.2em;

  /*  */
  ${mobile({
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(1, 1fr)",
    padding: "none",
  })}
  ${mobileM({
    padding: "0 40px",
    display: "grid",
    gridGap: "0.2em",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
    ${tablet({
    textAlign: "center",
    padding: "0 40px",
    display: "grid",
    gridGap: "0.2em",
    gridTemplateColumns: "repeat(2, 1fr)",
  })}
`;

const Card = styled.div`
  width: 100%;
  overflow: hidden;

  height: auto;
  padding: 1% 0 0.1% 0;
`;

//
//
const HomeScreen = () => {
  return (
    <>
      {/*  */}
      <HomeWrapper>
        <GalleryWrapper>
          <H1>Back in Stock</H1>
          <H2>SHOP NOW</H2>
          <GalleryProductContainer>
            {products
              .filter((product) => product.collection === "nubi")
              .map((product) => (
                <div key={product._id}>
                  <Card>
                    {" "}
                    <Product product={product} />
                  </Card>
                </div>
              ))}
          </GalleryProductContainer>
        </GalleryWrapper>{" "}
        <button type="button" className="link-All-products">
          <H1>New Designs</H1>
          <H3>
            <Link to="/allProducts" className="navLinks">
              View All
            </Link>
          </H3>
        </button>
      </HomeWrapper>
    </>
  );
};

export default HomeScreen;
